export function createFormData(data) {
  const formData = new FormData();

  for (let i in data) {
    if (data.hasOwnProperty(i) && data[i]) {
      if (typeof data[i] === 'object' && data[i].length > 1) {
        formData.append(i, data[i][0], data[i][1]);
      } else {
        formData.append(i, data[i]);
      }
    }
  }

  return formData;
}
